import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';
import AbortAddon from 'wretch/addons/abort';
import { PersonDataSchema, AbortError } from '@fe-learner-common';
import { localizedErrorHandlers } from '@fe-core/api';
import * as v from 'valibot';

const InstructorsDataSchema = v.object({
  instructors: v.array(PersonDataSchema),
  total: v.number(),
});

const InstructorsPayloadSchema = v.object({
  payload: InstructorsDataSchema,
});

export type TInstructorsData = v.Output<typeof InstructorsDataSchema>;

export type TInstructorsParams = {
  pageIndex: number;
  pageSize?: number | null;
  sort: string;
};

export const getInstructors = async (
  baseUrl: string,
  participationId: string,
  params?: TInstructorsParams,
  signal?: AbortSignal,
): Promise<TInstructorsData> => {
  const controller = new AbortController();

  const url = `${baseUrl}api/v2/participation/${participationId}/instructors`;
  const instance = wretch(url, {
    credentials: 'include',
  })
    .addon(AbortAddon())
    .signal(controller)
    .addon(QueryStringAddon)
    .query(params || {})
    .get()
    .onAbort(() => {
      throw new AbortError();
    });

  signal?.addEventListener('abort', () => {
    controller.abort();
  });

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(InstructorsPayloadSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output.payload;
    } else {
      console.error(
        'fe-learner-common | getInstructors | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid insctructors response');
    }
  });
};
